export default __webpack_public_path__ + "06172b92d604f8d730f823b27df44871.png";